import i18n from '../i18n/i18n';

/**
 * Returns the localized "N records" label. i18next picks the plural form
 * (`sectionState.recordCount.one|two|few|many|other|zero`) by the CLDR plural rules
 * of the current language, so e.g. Lithuanian "6 įrašai" or Polish "22 rekordy" are correct.
 */
export function getRecordsTranslate(count: number) {
  return i18n.t('sectionState.recordCount', {count});
}
